import React, {useContext, useEffect, useState} from "react";
import './FlipCard.css'
import ReactCardFlip from "react-card-flip";
import {ThemeContext} from "../../../../../../providers/themeContext/theme-context.tsx";

type FlipCardProps = {
    index: number,
    uuid: string,
    letter: string,
    correctWord: string,
    isFlip: boolean,
};

// 定一个只能在三个字符串的限定类型
type letterStatusType = 'correct' | 'position_wrong' | 'all_wrong';

// 可翻转的卡片
const FlipCard: React.FC<FlipCardProps> = ({index, letter, correctWord, isFlip, uuid}) => {
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);
    const [isFlipped, setIsFlipped] = useState<boolean>(false);
    const [letterStatus, setLetterStatus] = useState<letterStatusType>('all_wrong');

    // 根据传入的letter和correctWord判断当前字母的状态
    const getLetterStatus = () => {
        const correctWordList = correctWord.toUpperCase().split("");
        if (letter === correctWordList[index]) {
            setLetterStatus('correct');
            return;
        }
        if (correctWordList.includes(letter)) {
            setLetterStatus('position_wrong');
            return;
        }
        setLetterStatus('all_wrong');
    }

    useEffect(() => {
        // 判断字母的状态
        getLetterStatus();
        if (isFlip && !isFlipped) {
            const timer = setTimeout(() => {
                // 在这里触发翻转
                setIsFlipped(!isFlipped);
            }, index * 400 + 800);

            return () => clearTimeout(timer);
        }
    }, [index, isFlip, isFlipped, letter]);

    return (
        <ReactCardFlip isFlipped={isFlipped} flipDirection="vertical"
                       key={index.toString() + letter + uuid}>
            <div
                className="flip-card my-roboto-medium"
                style={{
                    backgroundImage: `url(${
                        isFlip ? imgUrls.letterAllWrongBgUrl : letterStatus === 'correct' ? imgUrls.letterAllRight : letterStatus === 'position_wrong' ? imgUrls.letterWrongPositionUrl : imgUrls.letterAllWrongBgUrl
                    })`
                }}>
                {letter}
            </div>
            <div
                className="flip-card my-roboto-medium"
                style={{
                    backgroundImage: `url(${
                        letterStatus === 'correct' ? imgUrls.letterAllRight : letterStatus === 'position_wrong' ? imgUrls.letterWrongPositionUrl : imgUrls.letterAllWrongBgUrl
                    })`
                }}>
                {letter}
            </div>
        </ReactCardFlip>
    );
};

export default FlipCard;